export default __webpack_public_path__ + "static/TRACTOCAMIONES-1dbf5c1a748a7a32d976eeeae953eff5.png";